import {
  BadgeCheck, Beef, BookUser, CalendarDays, FolderOpen, HandCoins, Handshake, House, Landmark, LandPlot, Map,
  ShieldCheck, Sprout, Trees, UserCog, Users, Wheat,
} from 'lucide-react'
import type { NavSection } from '../../core/router/navConfig'

/** Navegação do HubVerticalFarm (02/11/2026), na organização do menu do DP: seções
 *  recolhíveis, título em caixa alta e um item por módulo, cada um com a própria
 *  key `farm_<módulo>.view`.
 *
 *  A Farm é uma área só por baixo, decisão do dono em 02/11/2026: Fazendas, Produção
 *  e Financeiro, as três áreas do plano de 28/10, viraram seções, e o Administrativo
 *  entra como a última seção, com as MESMAS telas e as mesmas keys do HubTransGrãos.
 *
 *  Imóveis e Mapa ficam ativos no detalhe, `/farm/imoveis/:imovelId` e
 *  `/farm/mapa/:imovelId`, que não entram no menu. */
export const farmNav: NavSection[] = [
  {
    title: 'Visão geral',
    titleKey: 'nav.section.farmOverview',
    items: [
      { label: 'Início', labelKey: 'nav.home', path: '/farm', icon: House, ready: true, permission: 'farm_inicio.view' },
      { label: 'Mapa das fazendas', labelKey: 'nav.farmMap', path: '/farm/mapa', icon: Map, ready: true, matchNested: true, permission: 'farm_mapa.view' },
      { label: 'Agenda', labelKey: 'nav.farmAgenda', path: '/farm/agenda', icon: CalendarDays, ready: true, permission: 'farm_agenda.view' },
    ],
  },
  {
    title: 'Imóveis',
    titleKey: 'nav.section.farmProperties',
    items: [
      { label: 'Imóveis', labelKey: 'nav.farmProperties', path: '/farm/imoveis', icon: LandPlot, ready: true, matchNested: true, permission: 'farm_imoveis.view' },
      { label: 'Documentos', labelKey: 'nav.farmDocuments', path: '/farm/documentos', icon: FolderOpen, ready: true, permission: 'farm_documentos.view' },
      { label: 'Fundo e arrendamentos', labelKey: 'nav.farmFund', path: '/farm/fundo', icon: Landmark, ready: true, permission: 'farm_fundo.view' },
    ],
  },
  {
    title: 'Produção',
    titleKey: 'nav.section.farmProduction',
    items: [
      { label: 'Lavoura', labelKey: 'nav.farmCrops', path: '/farm/lavoura', icon: Wheat, ready: true, permission: 'farm_lavoura.view' },
      { label: 'Confinamento', labelKey: 'nav.farmFeedlot', path: '/farm/confinamento', icon: Beef, ready: true, permission: 'farm_confinamento.view' },
      { label: 'Floresta e carvão', labelKey: 'nav.farmForestry', path: '/farm/floresta', icon: Trees, ready: true, permission: 'farm_floresta.view' },
    ],
  },
  {
    title: 'Pessoas e financeiro',
    titleKey: 'nav.section.farmPeopleFinance',
    items: [
      { label: 'Equipe', labelKey: 'nav.farmTeam', path: '/farm/equipe', icon: Users, ready: true, permission: 'farm_equipe.view' },
      { label: 'Faturamento e custos', labelKey: 'nav.farmFinance', path: '/farm/financeiro', icon: HandCoins, ready: true, permission: 'farm_financeiro.view' },
    ],
  },
  {
    title: 'Cadastros',
    titleKey: 'nav.section.farmRecords',
    items: [
      { label: 'Parceiros', labelKey: 'nav.farmPartners', path: '/farm/cadastros/parceiros', icon: Handshake, ready: true, permission: 'farm_parceiros.view' },
      { label: 'Safras e culturas', labelKey: 'nav.farmSeasons', path: '/farm/cadastros/safras', icon: Sprout, ready: true, permission: 'farm_safras.view' },
      { label: 'Contatos', labelKey: 'nav.farmContacts', path: '/farm/cadastros/contatos', icon: BookUser, ready: true, permission: 'farm_contatos.view' },
    ],
  },
  {
    // As telas do Administrativo, as mesmas, em endereço da Farm: sem áreas visíveis,
    // quem administra a Farm não sai dela para cuidar de usuários e cargos.
    title: 'Administração',
    titleKey: 'nav.section.administration',
    items: [
      { label: 'Usuários', labelKey: 'nav.users', path: '/farm/usuarios', icon: UserCog, ready: true, matchNested: true, permission: 'users.view' },
      { label: 'Cargos', labelKey: 'nav.positions', path: '/farm/cargos', icon: BadgeCheck, ready: true, matchNested: true, permission: 'users.view' },
      { label: 'Auditoria', labelKey: 'nav.audit', path: '/farm/auditoria', icon: ShieldCheck, ready: true, permission: 'audit.view' },
    ],
  },
]
